import React from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import { MdEdit } from "react-icons/md";
import { HiTrash } from "react-icons/hi";

export default function PostItem({
	post,
	id,
	onEdit = false,
	onDelete = false,
}) {
	return (
		<li>
			<div className="relative rounded-md border border-gray-500 hover:border-blue-500 transition duration-200 ease-in-out shadow-md hover:shadow-xl">
				<Link to={`/post/${id}`}>
					<div className="overflow-hidden">
						<img
							className="object-cover bg-center rounded-t-md hover:scale-105 transition duration-200"
							src={post.imgUrl}
							alt={`${post.name}`}
							loading="lazy"
						/>
					</div>
				</Link>
				<div className="p-2">
					<Link to={`/post/${id}`}>
						<div className="flex flex-col">
							<h1 className="text-lg text-yellow-100 font-bold whitespace-nowrap truncate">
								{post.name}
							</h1>
							<div className="flex items-center font-bold whitespace-nowrap truncate">
								<p className="text-xs text-gray-500 mr-1">by</p>
								<h1 className="truncate">{post.artist}</h1>
							</div>
						</div>
					</Link>
					<div className="flex items-center justify-between">
						<h1 className="text-xs">
							Year of Release: {post.year}
						</h1>
						<h1 className="flex absolute bottom-24 right-2 px-2 text-md bg-orange-600 border border-white rounded-full text-white font-bold items-center">
							<p className="font-bold">{post.rating}</p>
							<p className="text-xs font-normal text-orange-200">
								/10
							</p>
						</h1>
					</div>
					<div className="absolute uppercase text-xs text-gray-100 top-2 left-2 px-2 py-1 m-1 bg-blue-600 rounded-full">
						<Moment fromNow>{post.timestamp?.toDate()}</Moment>
					</div>
					<div className="flex space-x-1 absolute bottom-2 right-2">
						{onEdit ? (
							<MdEdit
								onClick={() => {
									onEdit(id, post.name);
								}}
								className="cursor-pointer"
							/>
						) : (
							<></>
						)}
						{onDelete ? (
							<HiTrash
								onClick={() => {
									onDelete(id, post.name);
								}}
								className="cursor-pointer"
							/>
						) : (
							<></>
						)}
					</div>
				</div>
			</div>
		</li>
	);
}
